import "../scss/newsletter-principessa.scss"

import { Device } from "@/utils/device"
import { Form } from "../../../components/Form"
import type { WidgetAppProps, WidgetProps } from "../../../types/widget.props"

export function WidgetPrincipessa({ device, configuracaoSite, textosPersonalizados }: Readonly<WidgetProps>) {
    if (device !== Device.MOBILE && device !== Device.APP) return null

    return (
        <div className="widget-newsletter-container news-area">
            <h3 className="section-title">{textosPersonalizados.newsletterTitle}</h3>
            <form className="clearfix">
                <div className="input-container">
                    <Form
                        configuracaoSite={configuracaoSite}
                        textosPersonalizados={textosPersonalizados}
                        dinformname="newsletter-widget-principessa"
                        className={{
                            nome: "input-name",
                            email: "input-mail",
                            telefone: "input-phone",
                            button: "button button-small button-default"
                        }}
                    />
                </div>
            </form>
            <span>{textosPersonalizados.newsletterDescription}</span>
        </div>
    )
}

export default class WidgetPrincipessaApp {
    constructor(props: WidgetAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<WidgetPrincipessa {...props} />)
    }
}